<template>
  <div class="work-experience">
    <!-- 列表展示 -->
    <template v-if="!edit">
      <div class="work-experience_empty" v-if="data.length === 0">暂无教育经历</div>

      <div class="work-experience_list" v-else>
        <div :class="['experience-item', { 'no-last': index < data.length - 1 }]" v-for="(item, index) in data" :key="index">
          <div class="experience-item_header">
            <div class="header-info">
              <div class="info-time">{{ item.start_time }}-{{ item.end_time }}</div>
              <div class="info-school">{{ item.school_name }}</div>
              <div class="info-split"></div>
              <div class="info-post">{{ item.major }}</div>
            </div>

            <div class="header-operate">
              <div class="operate-btn" @click="handleEdit(index)">
                <i class="el-icon-edit"></i>
                <span>编辑</span>
              </div>

              <div class="operate-btn" @click="handleDelete(item.education_id)">
                <i class="el-icon-delete-solid"></i>
                <span>删除</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </template>

    <!-- 编辑 -->
    <template v-else>
      <el-form ref="form" :label-position="'top'" label-width="80px" :model="formData">
        <div class="row_box">
          <el-form-item label="学校名称">
            <el-input v-model="formData.school" placeholder="例如：大连枫叶职业技术学院"></el-input>
          </el-form-item>

          <el-form-item label="学制类型">
            <el-select style="width: 100%;" v-model="formData.system" placeholder="请选择">
              <el-option v-for="item in educationalSystem" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row_box">
          <el-form-item label="学历">
            <el-select style="width: 100%;" v-model="formData.educational" placeholder="请选择">
              <el-option v-for="item in Educational" :key="item.label" :label="item.value" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="专业">
            <el-input v-model="formData.professional" placeholder="例如：数字媒体应用技术"></el-input>
          </el-form-item>
        </div>

        <div class="row_box">
          <el-form-item label="时间段">
            <el-date-picker v-model="formData.time" type="monthrange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM" :picker-options="disableFutureMonths">
            </el-date-picker>
          </el-form-item>
        </div>

        <div class="row_box">
          <el-form-item label="在校经历(选填)" style="width: 800px">
            <el-input v-model="formData.at_school" type="textarea" :placeholder="contentPlaceholder" resize="none" row="7"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import { Educational, educationalSystem } from "../js/data";

export default {
  data() {
    return {
      formData: {
        time: [], // 时间
        school: "", // 学校名称
        system: "", // 学制
        educational: "", // 学历
        professional: "",
        at_school: "", // 在校经历
        education_id:null
      },
      contentPlaceholder: `1、在校担任职务;\n2、获得荣誉.;\n3、学主要课程...`,
      Educational: Educational,
      educationalSystem: educationalSystem,
      disableFutureMonths: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  props: ["data", "edit", "experience"],
  watch: {
    experience(val) {
      this.initData();
    },
  },
  methods: {
    initData() {
      console.log("this.experience", this.experience);

      if (this.experience) {
        this.formData.education_id=this.experience.education_id
        this.formData.time = [
          this.experience.start_time,
          this.experience.end_time,
        ]; // 时间
        this.formData.school = this.experience.school_name; // 学校名称
        this.formData.system = this.experience.program_type; // 学制
        this.formData.educational = this.experience.degree; // 学历
        this.formData.professional = this.experience.major;
        this.formData.at_school = this.experience.campus_experience; // 在校经历
      }
    },

    // 编辑
    handleEdit(index) {
      this.$emit("edit", index);
    },

    handleDelete(id) {
      this.$confirm("确定删除该学习经历?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$emit("delete", id);
      });
    },

    valid() {
      if (!this.formData.time) {
        this.$message.warning("请选择在校时间");
        return false;
      }

      if (!this.formData.school) {
        this.$message.warning("请输入学校名称");
        return false;
      }

      if (!this.formData.system) {
        this.$message.warning("请选择学制类型");
        return false;
      }

      if (!this.formData.educational) {
        this.$message.warning("请选择学历");
        return false;
      }

      // if (!this.formData.at_school) {
      //   this.$message.warning("请输入在校经历");
      //   return false;
      // }

      return true;
    },
  },

  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.work-experience {
  &_empty {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }

  &_list {
    .experience-item {
      & + .experience-item {
        margin-top: 16px;
      }

      padding-right: 48px;
      position: relative;

      &_header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-info,
        .header-operate {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .header-info {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #3b3b3b;

          .info-split {
            height: 16px;
            width: 1px;
            background-color: #d2d2d3;
          }
        }

        .header-operate {
          display: none;

          .operate-btn {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #685ef5;
            cursor: pointer;

            i {
              margin-right: 2px;
            }
          }
        }
      }

      &_content {
        .content-item {
          display: flex;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #6e6e6e;
          margin-top: 16px;

          & > * {
            flex-shrink: 0;
          }

          &_label {
            width: 45px;
            text-wrap: nowrap;
          }

          &_value {
            flex: 1;
            text-wrap: wrap;
            word-break: break-all;
          }
        }
      }

      &:hover {
        .header-operate {
          display: flex;
        }
      }

      &::before {
        position: absolute;
        content: "";
        top: 7px;
        left: -24px;
        width: 10px;
        height: 10px;
        background: #ffffff;
        border: 1px solid #d5d5d5;
        border-radius: 50%;
      }

      &.no-last {
        &::after {
          position: absolute;
          content: "";
          top: 20px;
          height: 100%;
          width: 2px;
          left: -19px;
          border-left: 1px dashed #d5d5d5;
        }
      }
    }
  }

  .row_box {
    width: 100%;
    display: flex;

    .el-form-item {
      flex-shrink: 0;
      width: 400px;
      margin-right: 40px;
    }
  }
}
</style>
